/* ==========================================================================
   Klarnaradens månad och PAY DAY-perioden (åtgärdslistan P1-03)

   Raden säger "Köp nu, betala i <nästa månad>": i oktober "november", den
   31 december "januari". Månaden stod tidigare som fast text i headerns
   inställningar och blev fel varje månadsskifte. Produktsidans äldre
   Klarnarad (snippets/buy-buttons.liquid) räknade två månader framåt.

   Räknas i svensk tid (Europe/Stockholm), inte i besökarens klocka, så att
   en kund utomlands ser samma sak som en kund i Sverige. Liquid skriver ut
   samma värde på servern; skriptet rättar det om sidan legat i Shopifys
   cache över ett månadsskifte.

   Den 25–30 varje månad visar bannern PAY DAY-texten i stället, om den är
   påslagen och har en procentsats i sektionens inställningar. Den 31:a är
   det Klarnatexten igen.

   Test: i förhandsgranskning av ett opublicerat tema kan datumet sättas med
   ?tp_klarna_date=ÅÅÅÅ-MM-DD. I det publicerade temat ignoreras parametern.

   Allt som ska uppdateras märks i markupen:
     [data-tp-klarna-month]   månadsnamnet
     [data-tp-klarna-banner]  bannern; med data-tp-payday kan den växla till
                              PAY DAY, och då finns [data-tp-klarna-default]
                              och [data-tp-klarna-payday] i den
   ========================================================================== */

(function () {
  var MONTHS = [
    'januari', 'februari', 'mars', 'april', 'maj', 'juni',
    'juli', 'augusti', 'september', 'oktober', 'november', 'december'
  ];

  function testDate() {
    try {
      var theme = window.Shopify && window.Shopify.theme;
      if (!theme || theme.role === 'main') return null;
      var m = /[?&]tp_klarna_date=(\d{4})-(\d{2})-(\d{2})/.exec(window.location.search);
      return m ? { y: Number(m[1]), m: Number(m[2]), d: Number(m[3]) } : null;
    } catch (error) {
      return null;
    }
  }

  /* Dagens datum i Stockholm som { y, m (1–12), d }. */
  function today() {
    var fixed = testDate();
    if (fixed) return fixed;
    try {
      var parts = {};
      new Intl.DateTimeFormat('sv-SE', {
        timeZone: 'Europe/Stockholm',
        year: 'numeric',
        month: 'numeric',
        day: 'numeric'
      }).formatToParts(new Date()).forEach(function (part) {
        parts[part.type] = Number(part.value);
      });
      if (parts.year && parts.month && parts.day) return { y: parts.year, m: parts.month, d: parts.day };
    } catch (error) {}
    var now = new Date();
    return { y: now.getFullYear(), m: now.getMonth() + 1, d: now.getDate() };
  }

  /* m är 1–12, och listan börjar på 0: index m är alltså nästa månad. */
  function nextMonthName(date) {
    return MONTHS[date.m % 12];
  }

  function isPayDay(date) {
    return date.d >= 25 && date.d <= 30;
  }

  function update(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var date = today();
    var month = nextMonthName(date);

    scope.querySelectorAll('[data-tp-klarna-month]').forEach(function (el) {
      if (el.textContent !== month) el.textContent = month;
    });

    scope.querySelectorAll('[data-tp-klarna-banner][data-tp-payday]').forEach(function (banner) {
      var payday = isPayDay(date);
      var normal = banner.querySelector('[data-tp-klarna-default]');
      var deal = banner.querySelector('[data-tp-klarna-payday]');
      if (normal) normal.hidden = payday;
      if (deal) deal.hidden = !payday;
    });
  }

  window.TPKlarnaMonth = { update: update, today: today, nextMonthName: nextMonthName, isPayDay: isPayDay };

  update(document);
  document.addEventListener('shopify:section:load', function (event) {
    update(event.target);
  });
})();
